import React, { FC } from "react";


import { useGetAppsForOrgQuery, useGetOrgsQuery } from "generated/graphql";

import { SimLoadingSpinner } from "@xapp/components";
import { existsAndNotEmpty } from "stentor-utils";

import { IntegrateConnect } from "../components/IntegrateConnect";
import { Redirect } from "react-router";

export const IntegrateConnectContainer: FC = () => {

    // need orgs
    const [getOrgs] = useGetOrgsQuery({
        requestPolicy: "cache-and-network",
        variables: {
            from: 0,
            size: 12 // this makes the next orgs call faster if we leave the pagination 12, which is what we use in other places
        }
    });

    const { data, fetching } = getOrgs;

    const orgsData = data?.orgs;
    const orgs = orgsData?.orgs;
    const orgsTotal = orgsData?.total;
    const org = existsAndNotEmpty(orgs) ? orgs[0] : undefined;
    const organizationId: string = org ? org.organizationId : undefined;

    // need apps
    const [getApps] = useGetAppsForOrgQuery({
        // don't make the request if they don't have an org OR they have more than one
        pause: !organizationId || orgsTotal > 1,
        requestPolicy: "cache-and-network",
        variables: {
            organizationId
        }
    });

    const { data: appData, fetching: appFetching } = getApps;

    const totalApps: number = appData?.org?.allApps?.total;
    const app = totalApps === 1 ? appData?.org?.apps?.apps[0] : undefined;

    // stall if any of the required data is missing
    if (fetching || appFetching) {
        return <SimLoadingSpinner />;
    }

    if (totalApps === 1 && app) {
        // only one app, redirect them to the integrations page for the app
        return <Redirect to={{
            pathname: `/${app.organizationId}/${app.appId}/settings/integrations`
        }} />;
    }

    return (<IntegrateConnect />);
}